
<ng-template [ngIf]="isEmittingMdp">
      <app-loading></app-loading>
</ng-template>
    <div class="d-flex mt-2">
            <form [formGroup]="emettiMdpForm">
                <div class="grid formgrid p-fluid">
                    <div class="field mt-2 mb-2 col-12">
                        <label for="inizioPeriodoRiferimento" class="font-medium text-900 text-green-600 font-bold">Periodo Riferimento</label>
                        <p-calendar formControlName="intervalloRiferimento" [readonlyInput]="true" selectionMode="range"  [appendTo]="'body'"></p-calendar>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="fase1" class="font-medium text-900 text-blue-600 ">FASE I</label>
                        <p-inputNumber mode="currency" inputId="fase1" currency="EUR" locale="it-IT" formControlName="fase1" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="fase2" class="font-medium text-900 text-blue-600 ">FASE II</label>
                        <p-inputNumber mode="currency" inputId="fase2" currency="EUR" locale="it-IT" formControlName="fase2" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="opereExtra" class="font-medium text-900 text-blue-600 ">OPERE EXTRA</label>
                        <p-inputNumber mode="currency" inputId="opereExtra" currency="EUR" locale="it-IT" formControlName="opereExtra" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="fase3" class="font-medium text-900 text-blue-600 ">FASE III</label>
                        <p-inputNumber mode="currency" inputId="fase3" currency="EUR" locale="it-IT" formControlName="fase3" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ko" class="font-medium text-900 text-blue-600 ">KO</label>
                        <p-inputNumber mode="currency" inputId="ko" currency="EUR" locale="it-IT" formControlName="ko" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2 ">
                        <label for="valore" class="font-medium text-900 text-blue-600 font-bold">COMPLESSIVO</label>
                        <p-inputNumber mode="currency" inputId="valore" currency="EUR" locale="it-IT" formControlName="valore" class="font-bold" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                 </div> 
            </form>
         
        
    </div>




<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
<div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
        class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isEmittingMdp || !emettiMdpForm.valid"></p-button>
</div>
<p-toast />
